export default __webpack_public_path__ + "static/media/express.bec2b4be.svg";